// src/lib/emitent.ts — datele de EMITENT ale hărții (PUR, partajat server↔client, zero dependințe).
//
// Șablonul oficial al certificatului scrie singur „Județul {emitent_judet}", deci atributul hărții
// trebuie să poarte DOAR numele județului. În practică se completa cu tot cu prefix („Județul
// Vaslui" — era chiar exemplul din formular), iar actul ieșea cu „Județul Județul Vaslui". Regula
// stă într-un singur loc și se aplică de două ori: la SCRIERE (`update_map`, ca valoarea stocată să
// fie curată) și la CITIRE (contextul de auto-completare, pentru valorile scrise înainte de regulă).

const JUDET_PREFIX = /^\s*(?:jude[tțţ](?:ul)?(?=[\s:]|$)|jud\.)\s*:?\s*/i

/**
 * Numele județului fără prefix: „Județul Vaslui" / „Judetul Vaslui" / „Jud. Vaslui" → „Vaslui".
 * Prefixul repetat se scoate și el („Județul Județul Vaslui"); restul textului rămâne neatins.
 */
export function judet_name(value: string): string {
	let out = value.trim()
	for (let i = 0; i < 4; i++) {
		const next = out.replace(JUDET_PREFIX, "")
		if (next === out) {
			break
		}
		out = next
	}
	return out.trim()
}
